import { createContext, useContext } from 'react';
import type { ShipmentDetail } from '@/lib/api/shipments';

/** The shipment the detail frame loaded; every tab reads it from here. */
export const ShipmentContext = createContext<ShipmentDetail | null>(null);

export function useShipment(): ShipmentDetail {
  const shipment = useContext(ShipmentContext);
  if (!shipment) throw new Error('useShipment() outside the shipment detail frame');
  return shipment;
}

/** The tabs of S02 (07 §3), in order; `path` under /shipments/$id. «Revisione»: ADR 0086. */
export const DETAIL_TABS = [
  { id: 'overview', path: '' },
  { id: 'timeline', path: 'timeline' },
  { id: 'route', path: 'route' },
  { id: 'reads', path: 'reads' },
  { id: 'deliveries', path: 'deliveries' },
  { id: 'history', path: 'history' },
  { id: 'review', path: 'review' },
] as const;
export type DetailTab = (typeof DETAIL_TABS)[number]['id'];

/** The reference shown for a shipment: Dokless's reference, else the first container, else the id. */
export function referenceOf(s: { reference: string | null; containers: string[]; id: string }): string {
  return s.reference ?? s.containers[0] ?? s.id;
}
